import "core-js";

import "bootstrap";
import "./unobtrusive-bootstrap.ts";

import moment from "moment";

import "select2/dist/js/select2.full.js";
import "tempusdominus-bootstrap-4";
import "jquery-validation";
import "jquery-validation/dist/additional-methods.js";

import "../css/site.scss";

export abstract class PodBase {
    constructor() {
        this.init();
    }

    private init() {
        ($("#bUser") as any).tooltip({ boundary: "window" });
        ($("body") as any).tooltip({ selector: '[data-toggle="tooltip"]', html: false, trigger: "hover", boundary: "window" });
        ($("body") as any).popover({ selector: '[data-toggle="popover"]', html: true, trigger: "hover" });

        ($.fn as any).select2.defaults.set("theme", "bootstrap4");
        ($.fn as any).select2.defaults.set("width", "100%"); // null does different


        ($("select") as any).not(".not-select2").select2(); // apply 'not-select2' class if we do not want it to apply


        ($(".nosearch") as any).select2({
            minimumResultsForSearch: Infinity
        }); // no search bar
    }

    static setAntiForgeryTokenHeaders(headerName: string, requestToken: string) {
        $.ajaxSetup({
            beforeSend: (xhr: any) => {
                xhr.setRequestHeader(headerName, encodeURIComponent(requestToken));
            }
        });
    }

    configureDatePicker() {
        ($.fn as any).datetimepicker.Constructor.Default = $.extend({}, ($.fn as any).datetimepicker.Constructor.Default, {
            icons: {
                time: "fa far fa-clock",
                date: "fa far fa-calendar",
                up: "fa far fa-arrow-up",
                down: "fa far fa-arrow-down",
                previous: "fa far fa-chevron-left",
                next: "fa far fa-chevron-right",
                today: "fa far fa-calendar-check-o",
                clear: "fa far fa-trash",
                close: "fa far fa-times"
            }
        });

        const datefield = document.createElement("input");
        datefield.setAttribute("type", "date");
        if (datefield.type != "date") { // if browser doesn't support input type="date", enable custom one
            ($(".datepicker") as any).each((_: number, picker: any) => {
                this.addDatePicker($(picker));
            });
        }
    }

    addDatePicker(picker: any) {
        // more fuss than it should be with current implementation of the lib
        const format = "YYYY-MM-DD";
        const date = moment(picker.val(), format).toDate();
        // add various bits only now we know we need it otherwise it's invasively used regardless
        picker.addClass("datetimepicker-input");
        picker.attr("data-toggle", "datetimepicker");
        picker.attr("data-target", `#${picker.attr("id")}`);
        // won't just use the input value without this manipulation
        picker.datetimepicker({ format: format, date: null });
        picker.datetimepicker("date", date);
    }

    isDate(txtDate: any) {
        const currVal = txtDate;
        if (currVal == "")
            return false;

        //Declare Regex
        const rxDatePattern = /^(\d{1,2})(\/)(\d{1,2})(\/)(\d{4})$/;
        const dtArray = currVal.match(rxDatePattern); // is format OK?

        if (dtArray == null)
            return false;

        //Checks for dd/mm/yyyy format.
        const dtDay = dtArray[1];
        const dtMonth = dtArray[3];
        const dtYear = dtArray[5];

        if (dtMonth < 1 || dtMonth > 12)
            return false;
        else if (dtDay < 1 || dtDay > 31)
            return false;
        else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31)
            return false;
        else if (dtMonth == 2) {
            const isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
            if (dtDay > 29 || (dtDay == 29 && !isleap))
                return false;
        }

        return true;
    }
    
    addTicket() {
        if (($("#frmTicket") as any).valid()) {
            //add id to hdn field, and item to div
            const id = $("#ddlTicket option:selected").val();
            const val = $("#ddlTicket option:selected").text();

            const exp: any= $("#txtTicketExpiry").val();

            if (exp.length > 0) {
                $("#tickets").append(`<li data-id='${id}' data-exp='${exp}' class="list-group-item p-1 px-2 bg-light">${val} <span class="badge badge-secondary">exp ${exp}</span><button type='button' data-id=${id} class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
                
            }
            else {
                $("#tickets").append(`<li data-id=${id} class="list-group-item p-1 px-2 bg-light">${val}<button type='button' data-id=${id} class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
            }

            $(`button[data-id='${id}']`).click((event: any) => this.removeTicket($(event.currentTarget).data("id")));

            this.rebuildTicketListString();

            ($("#add-ticket-modal") as any).modal("hide");
            $("#spTick").text($("#tickets li").length);
        }
    };

    removeTicket(id: number) {
        const select = `#tickets [data-id=${id}]`;
        $(select).remove();
        this.rebuildTicketListString();
        $("#spTick").text($("#tickets li").length);
    };
    
    openAddTicket() {
        // disable tickets already selected
        $("#ddlTicket option").removeAttr("disabled");
        $("#tickets li").each((_: number, element: any) => {
            const select = "#ddlTicket option[value=\"ID\"]".replace("ID", ($(element).attr("data-id")));
            $(select).attr("disabled", "disabled");
        });

        $("#ddlTicket").val("");
        $("#txtTicketExpiry").val("");

        ($("#add-ticket-modal") as any).modal();

        return false;
    };

    rebuildTicketListString() {
        var list = "";
        $("#tickets li").each((_: number, obj: any) => {
            const id = $(obj).attr("data-id");
            const exp = $(obj).attr("data-exp");
            list = list + id;
            if (exp != null && exp.length > 0) {
                list = list + "_" + exp;
            }
            list = list + ",";
        });
        $("#hdnTickets").val(list);

        // if any "no tickets" divs present, hide/show them
        if (list.length > 0) {
            $("#divNoTickets").hide();
        }
        else {
            $("#divNoTickets").show();
        }
    };

    toggleComments() {
        const decline = $("#radioDecline").is(":checked");
        if (decline) {
            $("#rowComments").show();
        }
        else {
            $("#rowComments").hide();
        }
    }

    readUrl(input: any) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                $("#img-upload").attr("src", e.target.result);
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    openAddCert() {
        // disable tickets already selected
        $("#ddlCert option").removeAttr("disabled");
        $("#certifications li").each((_: number, element: any) => {
            const select = "#ddlCert option[value=\"ID\"]".replace("ID", ($(element).attr("data-id")));
            $(select).attr("disabled", "disabled");
        });

        $("#ddlCert").val("");
        $("#txtCertExpiry").val("");
        ($("#add-cert-modal") as any).modal();
        return false;
    };

    addCert() {
        if (($("#frmCertification") as any).valid()) {
            //add id to hdn field, and item to div
            const id = $("#ddlCert option:selected").val();
            const val = $("#ddlCert option:selected").text();
            const exp: any = $("#txtCertExpiry").val();

            if (exp.length > 0) {
                $("#certifications").append(`<li data-id='${id}' data-exp='${exp}' class="list-group-item p-1 px-2 bg-light">${val}<span class="badge badge-secondary">exp ${exp}</span><button type='button' data-id=${id} class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
            }
            else {
                $("#certifications").append(`<li data-id=${id} class="list-group-item p-1 px-2 bg-light">${val}<button type='button' data-id=${id} class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
            }

            $(`button[data-id='${id}']`).click((event: any) => this.removeCertification($(event.currentTarget).data("id")));

            this.rebuildCertListString();
            ($("#add-cert-modal") as any).modal("hide");
            $("#spCert").text($("#certifications li").length);
        }
    }

    removeCertification(id: number) {
        const select = `#certifications [data-id=${id}]`;
        $(select).remove();
        this.rebuildCertListString();
        $("#spCert").text($("#certifications li").length);
    }
    
    rebuildCertListString() {
        var list = "";
        $("#certifications li").each((_: number, element: any) => {
            const id = $(element).attr("data-id");
            const exp = $(element).attr("data-exp");
            list = list + id;
            if (exp != null && exp.length > 0) {
                list = list + "_" + exp;
            }
            list = list + ",";
        });
        $("#hdnCertifications").val(list);
    };

    removePfTraining(id: number) {
        const select = `#pftraining [data-id=${id}]`;
        $(select).remove();
        this.rebuildPfTrainingListString();
        $("#spTrain").text($("#pftraining li").length);
    }

    removeHistory(id: number) {
        const select = `#divHistory [data-id=${id}]`;
        $(select).remove();
        this.rebuildHistoryListString();
        $("#spJobs").text($(".divhistory").length);
    }

    rebuildPfTrainingListString() {
        var list = "";
        $("#pftraining li").each((_: number, element: any) => {
            const id = $(element).attr("data-id");
            const exp = $(element).attr("data-exp");
            list = list + id;
            if (exp != null && exp.length > 0) {
                list = list + "_" + exp;
            }
            list = list + ",";
        });
        $("#hdnTraining").val(list);
    }

    rebuildHistoryListString() {
        var list: any[] = [];
        $(".divhistory").each((_: number, element: any) => {

            const thisNotes = $(".history_notes", element).html();

            const historyJson =
            {
                ID: $(element).attr("data-id"),
                CompanyID: $(element).attr("data-cid"),
                StartDate: $(element).attr("data-start"),
                EndDate: $(element).attr("data-end"),
                DaysDuration: $(element).attr("data-dur"),
                RatingPerformance: $(element).attr("data-per"),
                RatingPunctuality: $(element).attr("data-pun"),
                Notes: thisNotes,
                JobID: $(element).attr("data-jobid")
            };

            list.push(historyJson);
        });
        $("#hdnHistory").val(JSON.stringify(list));
    }

    openAddHistory() {
        $("#ddlHistCompany").val("");
        $("#txtCertExpiry").val("");
        ($("#add-history-modal") as any).modal();
        return false;
    };

    addHistory() {
        if (($("#frmHistory") as any).valid()) {
            //add id to hdn field, and item to div
            const cid = $("#ddlHistCompany option:selected").val();
            const cname = $("#ddlHistCompany option:selected").text();
            let start: any = $("#txtHistStart").val();
            let end: any = $("#txtHistEnd").val();
            const duration: any = $("#txtHistDuration").val();
            const performance = $("#ddlHistPerformance option:selected").val();
            const punctuality = $("#ddlHistPunctuality option:selected").val();
            const notes = $("#txtHistNotes").val();

            if (start.length == 0) start = "01/01/0001";//Datetime.Min
            if (end.length == 0) end = "01/01/0001";
            let durationtext = "";
            if (duration.length > 0) durationtext = `(duration:${duration} days)`;

            const fakeId = ($(".divhistory").length + 1) * -1;
            let perfStars = "";
            let puncStars = "";

            for (let i = 1; i < 6; i++) {
                if (performance >= i)
                    perfStars += "<i class=\"fas fa-star\"></i>";
                else
                    perfStars += "<i class=\"far fa-star\"></i>";

                if (punctuality >= i)
                    puncStars += "<i class=\"fas fa-star\"></i>";
                else
                    puncStars += "<i class=\"far fa-star\"></i>";
            }

            $("#divHistory").append(`<div data-jobid="-1" data-id="${fakeId}" data-cid="${cid}" data-start="${start}" data-end="${end}" data-dur="${duration}" data-per="${performance
                }" data-pun="${punctuality
                }"  class="card card-body bg-light p-1 text-muted mb-1 divhistory" style="font-size: small"> <div><b class="mr-2">${
                cname}</b> ${start} ${durationtext}</div> <div class="history_notes">${notes}</div> <div><span class="ml-0 mr-3 text-nowrap">Performance ${
                perfStars}</span><span class="ml-0 mr-3 text-nowrap">Punctuality ${puncStars}</span></div> <div><button type="button" data-id='${fakeId}' class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></div> </div>`);

            $(`button[data-id='${fakeId}']`).click((event: any) => this.removeHistory($(event.currentTarget).data("id")));

            this.rebuildHistoryListString();
            ($("#add-history-modal") as any).modal("hide");
            $("#spJobs").text($(".divhistory").length);
        }
    }

    openAddTraining() {
        // disable tickets already selected
        $("#ddlTraining option").removeAttr("disabled");
        $("#pftraining li").each((_: number, element: any) => {
            const select = "#ddlTraining option[value=\"ID\"]".replace("ID", ($(element).attr("data-id")));
            $(select).attr("disabled", "disabled");
        });

        $("#ddlTraining").val("");
        $("#txtTrainingExpiry").val("");
        ($("#add-training-modal") as any).modal();
        return false;
    };

    addTraining() {
        if (($("#frmPFTraining") as any).valid()) {
            //add id to hdn field, and item to div
            const id = $("#ddlTraining option:selected").val();
            const val = $("#ddlTraining option:selected").text();

            const exp: any = $("#txtTrainingExpiry").val();

            if (exp.length > 0) {
                $("#pftraining").append(`<li data-id='${id}' data-exp='${exp}' class="list-group-item p-1 px-2 bg-light">${val
                    } <span class="badge badge-secondary">exp ${exp}</span><button type='button' data-id='${id}' class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
            }
            else {
                $("#pftraining").append(`<li data-id=${id} class="list-group-item p-1 px-2 bg-light">${val}<button type='button' data-id='${id}' class="btn btn-sm btn-secondary float-right"><i class="fas fa-times"></i></button></li>`);
            }

            $(`button[data-id='${id}']`).click((event: any) => this.removePfTraining($(event.currentTarget).data("id")));

            this.rebuildPfTrainingListString();
            ($("#add-training-modal") as any).modal("hide");
            $("#spTrain").text($("#pftraining li").length);
        }
    }

    updateSMSSummary(txt: string) {

        //const smsmodal = $("#sms-op-modal");
        const summary = $(".smschars");

        summary.empty();
        var length = txt.length;
        if (length > 160) {
            var quantity = 1 + Math.ceil(length - 160 / 153);
            summary.append(`${length} characters (<span class='text-danger'>${quantity} SMS messages</span>)`);
        }
        else {
            summary.append(`${length} characters (1 SMS message)`);
        }
        
        
    }
}